import { useState, useEffect } from 'react';

/**
 * Given a boolean value, ensure the value stays true for a minimum amount of time
 */
const useStill = (pending: boolean, { min = 250 } = {}) => {
  const [prevPending, setPrevPending] = useState(false);
  const [stillPending, setStillPending] = useState(false);
  const [changeTime, setChangeTime] = useState<number>();
  const [timer, setTimer] = useState<NodeJS.Timeout>();

  useEffect(() => {
    if (pending !== prevPending) {
      clearTimeout(timer);

      if (pending) {
        setChangeTime(Date.now());
        setStillPending(true);
      }

      if (!pending) {
        const now = Date.now();
        const sinceChange = now - changeTime;

        if (sinceChange < min) {
          setTimer(setTimeout(() => {
            setStillPending(false);
          }, min - sinceChange));
        } else {
          setStillPending(false);
        }
      }

      setPrevPending(pending);
    }
  }, [pending, timer, prevPending, changeTime, min]);

  return stillPending;
};

export default useStill;
